var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"page-padding page-padding-all"},[_c('DataBox',{attrs:{"loading":false,"error":_vm.error}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }